/**
 * Editor + preview locale resources. Consumers (desktop client, Mini App)
 * merge these into their own i18next initialization alongside their
 * app-level namespaces.
 *
 *   import { editorLocaleResources, EDITOR_NAMESPACES } from '@tgpe/editor-core';
 *   const resources = {
 *     en: { ...editorLocaleResources.en, ...myAppEnNamespaces },
 *     ru: { ...editorLocaleResources.ru, ...myAppRuNamespaces },
 *   };
 */

import enEditor from './locales/en/editor.json';
import enPreview from './locales/en/preview.json';
import ruEditor from './locales/ru/editor.json';
import ruPreview from './locales/ru/preview.json';

export const EDITOR_NAMESPACES = ['editor', 'preview'] as const;
export type EditorNamespace = (typeof EDITOR_NAMESPACES)[number];

export const editorLocaleResources = {
  en: {
    editor: enEditor,
    preview: enPreview,
  },
  ru: {
    editor: ruEditor,
    preview: ruPreview,
  },
} as const;
